
import * as api from './api';
import { CrudApiService, CrudServiceProps } from "../ApiCrudService";

export const PermissionCrudService = function(props: 
  CrudServiceProps<api.Permission,string>
) {
  
  return CrudApiService<api.Permission,string>({...props, api: api, entityName: 'Permission'});

};